import clarity from '@microsoft/clarity';

// Inicializa Microsoft Clarity
// Reemplaza 'YOUR_PROJECT_ID' con tu Project ID de Clarity
export const initClarity = () => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  
  if (projectId) {
    clarity.init(projectId);
  } else {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Microsoft Clarity Project ID not found. Please set REACT_APP_CLARITY_PROJECT_ID environment variable.');
    }
  }
};

// Función opcional para identificar usuarios
export const identifyUser = (userId: string, sessionId?: string, pageId?: string, friendlyName?: string) => {
  clarity.identify(userId, sessionId, pageId, friendlyName);
};

// Función opcional para establecer tags personalizados
export const setTag = (key: string, value: string | string[]) => {
  clarity.setTag(key, value);
};

// Función opcional para trackear eventos personalizados
export const trackEvent = (eventName: string) => {
  clarity.event(eventName);
};